import Automations from './Automations';
// import PartnerDeviceCallout from './PartnerDeviceCallout';

// export { PartnerDeviceCallout };
export default Automations;
